export default __webpack_public_path__ + "static/media/start-k-8-med.adb01bce.jpg";